import type { ConfigField } from './configTypes'

// Define the configuration fields
export const CONFIG_FIELDS: ConfigField[] = [
  // BOL Info group
  {
    key: 'section-bol-info',
    name: 'BOL Info',
    columns: {},
    isSection: true,
  },
  {
    key: 'by_bol_number',
    name: 'By BOL #',
    description: 'Reconciliation will always consider BOL # in the matching criteria',
    columns: {
      match: 'always',
      approve: false,
      warning: false,
    },
  },
  {
    key: 'by_bol_date',
    name: 'By BOL Date',
    description: 'Match invoices within specified hours of the BOL date',
    unit: 'hrs',
    columns: {
      match: true,
      approve: false,
      warning: false,
    },
  },
  // Reference Data group
  {
    key: 'section-reference-data',
    name: 'Reference Data',
    columns: {},
    isSection: true,
  },
  {
    key: 'by_supplier',
    name: 'By Supplier',
    description: 'Matching based on supplier identity',
    columns: {
      match: true,
      approve: true,
      warning: false,
    },
  },
  {
    key: 'by_terminal',
    name: 'By Terminal',
    description: 'Matching based on terminal identity',
    columns: {
      match: true,
      approve: true,
      warning: false,
    },
  },
  // Volume group
  {
    key: 'section-volume',
    name: 'Volume',
    columns: {},
    isSection: true,
  },
  {
    key: 'by_total_gross_volume',
    name: 'By Total Gross Volume',
    description: 'Aggregate sum of gross volume across all products on the BOL',
    unit: '%',
    columns: {
      match: false,
      approve: true,
      warning: true,
    },
  },
  {
    key: 'by_total_net_volume',
    name: 'By Total Net Volume',
    description: 'Aggregate sum of net volume across all products on the BOL',
    unit: '%',
    columns: {
      match: false,
      approve: true,
      warning: true,
    },
  },
  {
    key: 'by_total_amount',
    name: 'By Total',
    description: 'Total ($) of the invoice',
    unit: '$',
    columns: {
      match: true,
      approve: true,
      warning: true,
    },
  },
  {
    key: 'by_total_per_unit',
    name: 'By Total Per Unit',
    description: 'Total invoice amount divided by the total volume ($ per unit)',
    unit: '%',
    columns: {
      match: false,
      approve: true,
      warning: true,
    },
  },
  {
    key: 'by_total_product_cost',
    name: 'By Product Total',
    description: 'Sum of all product charges excluding taxes and additional fees',
    unit: '%',
    columns: {
      match: true,
      approve: true,
      warning: true,
    },
  },
  {
    key: 'by_tax_total',
    name: 'By Tax Total',
    description: 'Sum of all tax charges on the invoice or BOL',
    unit: '%',
    columns: {
      match: false,
      approve: true,
      warning: true,
    },
  },
]
